export default "__VITE_ASSET__xSpi2QyF__"